import api from '@/shared/api/client'

// ── Response types ──

export interface ChatwootIdentity {
  identifier: string
  identifier_hash: string
}

export const chatwootApi = {
  /**
   * HMAC-signed identity for the support widget. The signing key lives only on
   * the server, so the hash cannot be produced in the browser.
   */
  identity: () =>
    api.get<{ data: ChatwootIdentity }>('/support/chatwoot-identity').then((r) => r.data),
}
